// eslint-disable-next-line import/no-unused-modules
export type BuildMode = "production" | "development";

export function appendCacheBuster(name: string): string {
	return `${name}?v=${BuildInfo.version}-${BuildInfo.commitSha}`;
}

export class BuildInfo {
	public static get mode(): BuildMode {
		return process.env.BUILD_MODE === "production"
			? "production"
			: "development";
	}

	public static get version(): string {
		return process.env.VERSION as string;
	}

	public static get commitSha(): string {
		return process.env.COMMIT_SHA as string;
	}
}
